<template>
  <div class="single-view home">
    <view-background
      ref="background"
      :background="background"/>

    <hero-block
      :title="title"
      :subtitle="subtitle"
      :animate-in="entering"
      :animation-direction="animationDirection" />

    <content-wrapper>
      <one-column-content>
        <header class="block--header">
          <h2>Un team esperto di analisti, consulenti e ricercatori.</h2>
        </header>

        <div class="block--content">
          <h3>Azienda</h3>
          <h4>Dal 1980 POLOLAB, fondato da Maurizio Polo, offre servizi di analisi enologiche e per il settore agroalimentare, rapidi e di alta qualità, nel rispetto degli standard internazionali, ponendo costantemente il cliente al centro della propria organizzazione.</h4>

          <figure>
            <picture>
              <source media="(min-width: 700px)" :srcset="require('@/assets/home/esaminatore-vini.jpg')">
              <img :src="require('@/assets/home/esaminatore-vini.jpg')  " alt="Design Rossetto">
            </picture>
          </figure>

          <h3>Le nostre garanzie</h3>
          <h4>Siamo in grado di garantire:</h4>
          <p>
            <ul>
              <li>
                <p><strong>Consulenze personalizzate per la gestione di situazioni complesse.</strong><br />Dalla valutazione del grado di maturazione delle uve all’imbottigliamento, non esiste un problema senza soluzione. I nostri enologi sono in grado di assistere le aziende nel pianificare e gestire ogni tipologia di attività di cantina. Lo staff, formatosi negli anni, cresce costantemente con l’ingresso di nuovi tecnici e laureati e può offrire un servizio puntuale e risolutivo. Laboratorio Polo è in grado di seguire l’intero ciclo viticolo, definendo con il cliente la strategia più adeguata ad ottenere uve e vini di ottima qualità. Nel tempo abbiamo affinato la nostra particolare sensibilità ai temi dell’ambiente, adeguando la struttura al fine di fornire servizi e assistenza per la produzione di vini biologici.</p>
              </li>
              <li>
                <p><strong>Massima focalizzazione sull'innovazione scientifica</strong> grazie alla collaborazione con università e istituti di ricerca. <br /></p>
              </li>
              <li>
                <p><strong>Logistica di qualità superiore</strong>, con invio dei risultati dopo solo 24/36 ore dalla presa del campione (entro la giornata per il Triveneto).</p>
              </li>
              <li>
                <p><strong>Costi contenuti</strong>, elevata qualità e tempi di risposta ridotti al minimo.</p>
              </li>
            </ul>
          </p>

          <figure class="figure--padded">
            <picture>
              <source media="(min-width: 700px)" :srcset="require('@/assets/home/provetta-con-vino.jpg')">
              <img :src="require('@/assets/home/provetta-con-vino.jpg')" alt="Design Rossetto">
            </picture>
          </figure>

          <h3>La struttura e il gruppo</h3>
          <h4>Oggi POLOLAB sorge in un'area di 13.000 mq, accanto agli stabilimenti di <a href="https://www.bioenologia.com/azienda">Bioenologia 2.0</a>.</h4>

          <p>
            Con oltre 1.000 metri quadri di laboratorio, POLOLAB dispone di strumentazioni all'avanguardia e può contare su un team di 40 persone, tra tecnici e microbiologi molecolari, che lo collocano a livello nazionale tra le eccellenze del settore. 20.000 test effettuati ogni anno, garantiscono la qualità di oltre 70 milioni di bottiglie.
          </p>

          <div class="block--content__quote">
            <h4>Mission</h4>
            <p>POLOLAB si prefigge di fornire ad aziende e professionisti servizi di elevata qualità nell’ambito delle analisi di laboratorio, sofisticate soluzioni e protocolli di gestione dei processi produttivi per il settore enologico e agroalimentare.</p>
          </div>

          <figure>
            <picture>
              <source media="(min-width: 700px)" :srcset="require('@/assets/home/laboratorio_2022.jpg')">
              <img :src="require('@/assets/home/laboratorio_2022.jpg')  " alt="Design Rossetto">
            </picture>
          </figure>

          <h3>Vision</h3>
          <h4>POLOLAB adotta standard internazionali allo scopo di posizionarsi all'apice delle eccellenze nel panorama del settore, mediante un'offerta all'avanguardia in ambito professionale, tecnologico e organizzativo.</h4>
          <h4>Compete per garantire sicurezza, efficacia, efficienza e tempestività.</h4>

          <p>
            <ul>
              <li>
                <p><strong>Centralità del cliente.</strong> Il cliente è al centro del processo aziendale e la struttura si adatta ed evolve costantemente per rispondere alle sue esigenze in modo rapido, sicuro, efficace.</p>
              </li>
              <li>
                <p><strong>Valorizzazione dei collaboratori.</strong> Il personale di POLOLAB possiede elevate competenze professionali e tecniche, frutto della continua attività di aggiornamento e condivisione.</p>
              </li>
              <li>
                <p><strong>Eccellenza.</strong> POLOLAB persegue con tenacia il miglioramento continuo dei propri standard qualitativi e di sicurezza, nel rispetto del sistema di qualità totale e dei requisiti richiesti dalle certificazioni adottate dall'azienda. Ogni nuova problematica è una sfida da affrontare con rigore e razionalità.</p>
              </li>
              <li>
                <p><strong>Sostenibilità.</strong> Coscienza verde non è solo uno slogan; POLOLAB ha installato nei propri stabilimenti tre impianti fotovoltaici, il primo nel 2011, con una produzione complessiva di 230.000 kWh annui. Inoltre, tutto il processo aziendale è orientato alla sostenibilità, con una maniacale attenzione agli sprechi e all'impatto con l'ambiente.</p>
              </li>
            </ul>
          </p>

          <figure>
            <picture>
              <source media="(min-width: 700px)" :srcset="require('@/assets/home/Pololab.jpg')">
              <img :src="require('@/assets/home/Pololab.jpg')  " alt="Design Rossetto">
            </picture>
          </figure>
        </div>
      </one-column-content>
    </content-wrapper>
    <global-footer />
  </div>
</template>

<script>
import guards from './SingleView/guards'
import garbage from './SingleView/garbage'
import backgrounds from './SingleView/backgrounds'
import HeroBlock from '../components/HeroBlock'
import ContentWrapper from '../components/ContentWrapper'
import GlobalFooter from '../components/GlobalFooter'
import OneColumnContent from '../components/ContentWrapper/OneColumnContent'
import ViewBackground from '../components/ViewBackground'
import { mapMutations } from 'vuex'

export default {
  mixins: [ guards, garbage, backgrounds ],
  components: {
    HeroBlock,
    ContentWrapper,
    GlobalFooter,
    OneColumnContent,
    ViewBackground
  },
  data: () => ({
    title: 'Il laboratorio',
    subtitle: 'Più di 40 anni di ricerca e innovazione in campo enologico.',
    bgName: 'home'
  }),
  methods: {
    ...mapMutations('animations', [
      'updateMouseCursor'
    ])
  }
}
</script>

<style lang="scss">
@import '../assets/scss/breakpoint.scss';
@import '../assets/scss/mixins.scss';

$purple: #0a2f75;
$marginLeft: 7.5%;
$marginRight: 7.5%;
$marginLeftDesktop: 15%;
$marginRightDesktop: 15%;

.home{
  h3{
    color: $purple;
  }
  li{
    h3{
      color: $purple;
    }
    p{
      color: $purple;
      width: calc(100% - 20px);
    }
  }

  .block--content {
    ul {
      @include slashedList();
    }

    h3, h4 {
      margin-left: $marginLeft;
      margin-right: $marginRight;

      @include media(">=large") {
        margin-left: $marginLeftDesktop;
        margin-right: $marginRightDesktop;
      }
    }
  }

  .block--content__quote {
    h4 {
      margin: 0;
    }
  }
}

</style>
